import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "../environment/env.json";

export interface SchemeData {
  /** TODO: Fill with attributes */
  placeholder: string;
}

export class SchemeDataService {
  private httpClient = makeHttpClient();

  getAll() {
    return _unwrapAxiosResponse(
      this.httpClient.get<SchemeData[]>(env.schemeUrl)
    );
  }

  get(id: string) {
    return _unwrapAxiosResponse(
      this.httpClient.get<SchemeData>(`${env.schemeUrl}${id}`)
    );
  }

  getByCountry(countryId: number) {
    const url = env.schemeUrl + "?country=" + countryId;
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  update(id: string, data: SchemeData) {
    return _unwrapAxiosResponse(
      this.httpClient.put(`${env.schemeUrl}${id}/`, data)
    );
  }
}

export default SchemeDataService;
